/* Page Comparateur, section « Comment choisir » : niveau, bloc noir, piliers en accordéon, réglettes, icônes animées,
   scènes. Tiré du prototype validé par Gillian le 08.10.2026 (accordéon validé sur son iPhone, iOS 26.6.2). */
(function () {
  "use strict";
  var sectionEl = document.querySelector(".cmpg");
  var CONF = sectionEl && document.getElementById("cmpg-config");
  if (!sectionEl || !CONF) return;
  CONF = JSON.parse(CONF.textContent);
  var NIVEAUX = CONF.niveaux, PRIO = CONF.prio;
  // une entrée par raquette, comme dans le prototype : niveau, genre, 5 notes
  var DATA = Object.keys((window.psComparateur && window.psComparateur.data) || {}).map(function (h) {
    var r = window.psComparateur.data[h];
    return { l: r.levelHandle, g: r.genderHandle, power: r.power, control: r.control, comfort: r.comfort, spin: r.spin, maneuverability: r.maneuverability };
  });
  var AXES = { puissance: "power", controle: "control", confort: "comfort", spin: "spin", maniabilite: "maneuverability" };
  var REDUIT = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  sectionEl.classList.add("est-js");


  /* ---- Repères : zone où se trouvent la plupart des raquettes d'un niveau (10 % les plus bas et 10 % les plus hauts écartés, au moins 7 sur 10 dedans), point = moyenne ---- */
  function groupe(niv) {
    return DATA.filter(function (r) {
      if (niv === "debutant") return r.l === "debutant" && r.g !== "junior";
      if (niv === "avance") return r.l === "avance" || r.l === "elite";
      return r.l === niv;
    });
  }
  function quantile(v, p) {
    var t = v.slice().sort(function (a, b) { return a - b; });
    var i = (t.length - 1) * p, b = Math.floor(i), h = Math.min(b + 1, t.length - 1);
    return t[b] + (t[h] - t[b]) * (i - b);
  }
  var STATS = {};
  Object.keys(NIVEAUX).forEach(function (niv) {
    var g = groupe(niv);
    STATS[niv] = {};
    Object.keys(AXES).forEach(function (p) {
      var v = g.map(function (r) { return r[AXES[p]]; });
      var moy = v.reduce(function (a, b) { return a + b; }, 0) / v.length;
      STATS[niv][p] = { n: v.length, lo: Math.round(quantile(v, .1)), hi: Math.round(quantile(v, .9)), med: Math.round(moy) };
    });
  });

  function t(id) { return CONF.textes[id] != null ? CONF.textes[id] : ""; }
  function remplir(gabarit, v) { return gabarit.replace(/\{(\w+)\}/g, function (m, k) { return v[k] != null ? v[k] : m; }); }

  // les trois phrases sont empilées au même endroit (une ligne d'écart au plus entre elles) : la réglette ne bouge pas
  // quand le niveau change
  function phrasesRegles() {
    sectionEl.querySelectorAll(".pil").forEach(function (carte) {
      var p = carte.getAttribute("data-pilier"), txt = carte.querySelector(".regle__txt");
      if (!txt) return;
      txt.classList.add("empile");
      txt.innerHTML = Object.keys(NIVEAUX).map(function (niv) {
        var s = STATS[niv][p];
        if (!s.n) return "";
        return '<span data-niveau="' + niv + '">' + remplir(t("regle.gabarit"), { prefixe: t("regle.prefixe." + niv), critere: t("regle.critere." + p), bas: "<b>" + s.lo + "</b>", haut: "<b>" + s.hi + "</b>", moyenne: "<b>" + s.med + "</b>" }) + "</span>";
      }).join("");
    });
  }
  phrasesRegles();

  /* ---- Sélecteur de niveau ---- */
  var piste = sectionEl.querySelector(".niveau__piste");
  var curseur = sectionEl.querySelector(".niveau__curseur");
  var radios = Array.prototype.slice.call(sectionEl.querySelectorAll("input[name=niveau]"));
  var annonce = document.getElementById("annonce-niveau");
  var minuterieAnnonce = null;

  function niveauCourant() {
    var r = radios.filter(function (x) { return x.checked; })[0];
    return r ? r.value : "debutant";
  }
  // Curseur = boîte du libellé coché, au sous-pixel. Il est placé dans la boîte de padding de la piste (left: 0), comme
  // le libellé : rien à retrancher (l'ancien « - 3 » le collait au bord gauche, 3 px trop tôt, constaté le 08.10).
  function placerCurseur() {
    var r = radios.filter(function (x) { return x.checked; })[0];
    if (!r || !curseur || !piste) return;
    var lab = r.parentNode.getBoundingClientRect(), p = piste.getBoundingClientRect();
    if (!lab.width) return; // section non affichée : mesure à la prochaine taille connue
    // première pose sans animation : sinon, section à l'écran au chargement, la pastille repoussait depuis une largeur 0
    // et le texte blanc restait un instant sur fond clair (revue du 08.10)
    var premiere = !curseur.hasAttribute("data-pose");
    if (premiere) { curseur.style.transition = "none"; curseur.setAttribute("data-pose", ""); }
    curseur.style.setProperty("--x", (lab.left - p.left - piste.clientLeft) + "px");
    curseur.style.setProperty("--w", lab.width + "px");
    if (premiere) { void curseur.offsetWidth; curseur.style.transition = ""; }
  }
  // Les libellés changent de largeur quand la police du site arrive après le premier affichage (première visite) :
  // on suit chaque libellé, pas seulement la piste, et on remesure quand les polices sont prêtes.
  if (window.ResizeObserver && piste) {
    var suiviNiveaux = new ResizeObserver(placerCurseur);
    suiviNiveaux.observe(piste);
    radios.forEach(function (x) { suiviNiveaux.observe(x.parentNode); });
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(placerCurseur);

  // Conseils et bloc noir : la hauteur suit la variante affichée (styles .empile--suit). Au changement de niveau, elle
  // glisse de l'ancienne à la nouvelle, au lieu de sauter ; mouvement réduit : changement direct.
  var suivies = Array.prototype.slice.call(sectionEl.querySelectorAll(".conseil .empile, .verdict__empile"));
  suivies.forEach(function (e) { e.classList.add("empile--suit"); });
  // PC : le fond noir du bloc est un calque (styles) à la hauteur de la variante affichée. Il glisse au changement de
  // niveau ; il suit sans glisser les changements de largeur (et la première pose).
  var pileNoire = sectionEl.querySelector(".verdict__empile");
  function poserNoir(anime) {
    var on = pileNoire && pileNoire.querySelector(".is-on");
    if (!on) return;
    if (!anime) pileNoire.style.setProperty("--noir-transition", "none");
    // hauteur exacte (pas offsetHeight, arrondi : le calque dépassait la plus haute variante et la colonne bougeait de 0,4 px)
    pileNoire.style.setProperty("--h-noir", on.getBoundingClientRect().height + "px");
    if (!anime) { void getComputedStyle(pileNoire, "::before").height; pileNoire.style.removeProperty("--noir-transition"); }
  }
  if (window.ResizeObserver && pileNoire) {
    var suiviNoir = new ResizeObserver(function () { poserNoir(false); });
    Array.prototype.forEach.call(pileNoire.children, function (v) { suiviNoir.observe(v); });
  }
  function libererHauteur(e) { e.style.transition = ""; e.style.height = ""; e.style.overflow = ""; }
  function glisser(e, de) {
    clearTimeout(e._finGlisse);
    var a = e.offsetHeight; // hauteur de la nouvelle variante (hauteur imposée retirée avant le changement)
    if (REDUIT || !de || !a || Math.abs(a - de) < 1) { libererHauteur(e); return; }
    e.style.transition = "none";
    e.style.overflow = "hidden";
    e.style.height = de + "px";
    void e.offsetHeight;
    e.style.transition = "height 260ms cubic-bezier(.2, .7, .2, 1)";
    e.style.height = a + "px";
    e._finGlisse = setTimeout(function () { libererHauteur(e); }, 320);
  }

  // PC, colonne du niveau collante (revues du 08.10) : quand la hauteur du conseil change, le niveau cliqué ne doit pas
  // bouger sous la souris, ni la page sous les yeux quand on lit plus bas. La colonne est accrochée au bas des cartes
  // (sa zone de grille) : tant que ce bas ne remonte pas au-dessus de sa position collée, elle ne bouge pas. Le repère
  // est donc toujours l'élément qui suit le conseil ouvert (scène ou « Ce que le comparateur évalue »), qui bouge d'un
  // bloc avec le bas des cartes ; jamais le libellé, collant, dont la position ne suit pas le défilement de façon
  // linéaire (la compensation s'y reprenait à 150 et 450 ms). Relevé avant le changement, décidé après la bascule :
  //  - colonne retenue en bas de la section, ou conseil sorti de la vue par le haut (plus de sa moitié au-dessus) : la
  //    suite reste à sa place, donc le bas des cartes et la colonne aussi ;
  //  - colonne collée, mais le conseil raccourcit de plus que la place qui lui reste avant d'être poussée : la page
  //    défile juste de quoi garder la colonne collée (sinon le niveau montait sous la souris, jusqu'à 98 px en allemand) ;
  //  - sinon (conseil à l'écran, colonne qui ne bouge pas ; mobile, tablette en portrait) : rien, la hauteur glisse.
  function releverColonne() {
    var pilote = sectionEl.querySelector(".pil-pilote");
    if (!pilote || getComputedStyle(pilote).position !== "sticky") return null;
    var conseil = sectionEl.querySelector(".pil.is-ouvert .conseil"), suite = conseil && conseil.nextElementSibling;
    if (!suite) return null; // aucun pilier ouvert : sur PC, rien ne change de hauteur (bloc noir à place constante)
    var colle = parseFloat(getComputedStyle(pilote).top) || 0, rp = pilote.getBoundingClientRect(), rc = conseil.getBoundingClientRect();
    return {
      suite: suite,
      haut: suite.getBoundingClientRect().top,
      retenue: rp.top < colle - 0.5,
      lu: (rc.top + rc.bottom) / 2 < colle,
      place: Math.max(0, sectionEl.querySelector(".pil-cartes").getBoundingClientRect().bottom - rp.bottom)
    };
  }
  function repereApres(c) {
    var d = c.suite.getBoundingClientRect().top - c.haut; // déplacement de tout ce qui suit le conseil
    if (Math.abs(d) < 0.5) return null;
    if (c.retenue || c.lu) return { el: c.suite, haut: c.haut };
    if (c.place + d < -0.5) return { el: c.suite, haut: c.haut - c.place };
    return null;
  }

  function appliquer(niv, annoncer) {
    var colonne = annoncer ? releverColonne() : null;
    // hauteur à l'écran avant le changement (en plein glissement si on change vite), puis hauteur imposée retirée
    var avant = suivies.map(function (e) {
      var h = e.getBoundingClientRect().height;
      clearTimeout(e._finGlisse);
      libererHauteur(e);
      return h;
    });
    sectionEl.querySelectorAll(".empile").forEach(function (e) {
      Array.prototype.forEach.call(e.children, function (c) { c.classList.toggle("is-on", c.getAttribute("data-niveau") === niv); });
    });
    poserNoir(annoncer);
    // hauteurs définitives à ce stade (pas encore de glissement) : lu dans la même tâche, rien n'est affiché entre-temps
    var rf = colonne ? repereApres(colonne) : null, repere = rf && rf.el, hautRepere = rf ? rf.haut : 0;
    if (repere) {
      // changement d'un coup, puis une seule compensation en position absolue, dans la même tâche : rien ne bouge à
      // l'écran. Même méthode que l'accordéon (candidats essayés, rappels à 150 et 450 ms, abandonnés au toucher).
      annulerRelance();
      var sc = compenser(repere, hautRepere);
      relances = [150, 450].map(function (ms, i) {
        return setTimeout(function () { if (i === 1) relances = []; reaffirmer(sc, repere, hautRepere, ms + " ms"); }, ms);
      });
    } else if (annoncer) suivies.forEach(function (e, i) { glisser(e, avant[i]); });
    sectionEl.querySelectorAll(".pil").forEach(function (carte) {
      var p = carte.getAttribute("data-pilier");
      carte.classList.toggle("is-prio", PRIO[niv].indexOf(p) >= 0);
      var s = STATS[niv][p];
      var bloc = carte.querySelector(".regle-bloc");
      if (bloc && s && s.n) {
        bloc.style.setProperty("--lo", s.lo); bloc.style.setProperty("--hi", s.hi); bloc.style.setProperty("--med", s.med);
      }
      carte.querySelectorAll(".conseil__niv b").forEach(function (b) { b.textContent = t("niveaux." + niv + ".nom"); });
    });
    placerCurseur();
    if (annoncer && annonce) {
      clearTimeout(minuterieAnnonce);
      minuterieAnnonce = setTimeout(function () {
        var noms = PRIO[niv].map(function (p) { return sectionEl.querySelector("#pilier-" + p + " .pil__titre").textContent.trim(); });
        annonce.textContent = remplir(t("runtime.annonce_niveau"), { nom: t("niveaux." + niv + ".nom"), a: noms[0], b: noms[1] });
      }, 500);
    }
  }
  radios.forEach(function (r) { r.addEventListener("change", function () { appliquer(r.value, true); }); });
  appliquer(niveauCourant(), false);

  /* ---- « Ce que le comparateur évalue » ---- */
  sectionEl.querySelectorAll(".evalue-btn").forEach(function (b) {
    var panneau = document.getElementById(b.getAttribute("aria-controls"));
    var minuterie = null;
    b.addEventListener("click", function () {
      var ouvrir = b.getAttribute("aria-expanded") !== "true";
      b.setAttribute("aria-expanded", String(ouvrir));
      clearTimeout(minuterie);
      if (ouvrir) {
        panneau.hidden = false;
        void panneau.offsetHeight;
        panneau.classList.add("is-open");
      } else {
        panneau.classList.remove("is-open");
        minuterie = setTimeout(function () { panneau.hidden = true; }, REDUIT ? 0 : 300);
      }
    });
  });

  /* ---- Piliers en accordéon : un seul ouvert à la fois, Puissance à l'arrivée ; aucun défilement commandé ---- */
  function visible(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }
  var cartes = Array.prototype.slice.call(sectionEl.querySelectorAll(".pil"));
  var scenes = Array.prototype.slice.call(sectionEl.querySelectorAll(".scene"));
  var minuteries = new Map();

  // l'icône du pilier ouvert joue son geste (calques de l'icône d'origine)
  var finsIcones = new Map();
  function jouerIcone(c) {
    if (REDUIT) return;
    clearTimeout(finsIcones.get(c));
    c.classList.remove("ico-joue");
    void c.offsetWidth;
    c.classList.add("ico-joue");
    // geste terminé : on retire la classe, l'icône redevient l'image d'origine sans aucun style d'animation
    finsIcones.set(c, setTimeout(function () { c.classList.remove("ico-joue"); }, 2600));
  }
  function entreeRegle(c) {
    if (REDUIT) return;
    var bloc = c.querySelector(".regle-bloc");
    bloc.classList.remove("is-entree");
    bloc.classList.add("is-pre");
    void bloc.offsetWidth;
    bloc.classList.add("is-entree");
    bloc.classList.remove("is-pre");
    setTimeout(function () { bloc.classList.remove("is-entree"); }, 800);
  }
  function fermer(c, net) {
    var btn = c.querySelector(".pil__btn"), pan = c.querySelector(".pil__panneau");
    // déjà fermé : rien, sauf s'il finit encore de se replier et qu'on le veut replié tout de suite
    if (btn.getAttribute("aria-expanded") !== "true" && (pan.hidden || !net)) return;
    btn.setAttribute("aria-expanded", "false");
    c.classList.remove("is-ouvert", "ico-joue");
    rearmer(c);
    clearTimeout(minuteries.get(c));
    if (net || REDUIT) {
      pan.style.transition = "none";
      pan.classList.remove("is-open");
      pan.hidden = true;
      void pan.offsetHeight;
      pan.style.transition = "";
      return;
    }
    pan.classList.remove("is-open");
    minuteries.set(c, setTimeout(function () { pan.hidden = true; }, 350));
  }
  // Un pilier ouvert AU-DESSUS se replie d'un coup et la page rend aussitôt la hauteur libérée, en un seul défilement :
  // le titre touché ne bouge pas. L'ancrage du défilement des navigateurs est coupé sur la page (CSS) : avec celui de
  // Safari (actif depuis 2026, WebKit 298514) en plus du nôtre, la vue remontait deux fois (iPhone, 08.10).
  // Filet de sécurité : deux images plus tard, si un navigateur a quand même déplacé le titre, un dernier rattrapage.
  // Jamais de correction image par image (tremblement sur iPhone le 06.10).
  // Les éléments qui PEUVENT défiler autour du titre : conteneurs, <body>, document. Un lecteur peut faire défiler autre
  // chose que la fenêtre ; window.scrollBy ne faisait alors rien (iPhone, version 8 : titre parti à −831 px). Les styles
  // ne suffisent pas à trancher : un <body> en « overflow: auto » peut ne pas défiler du tout (son défilement est alors
  // celui du document) — reproduit au banc, même −831 px. On essaie donc chaque candidat et on garde celui qui a bougé.
  var retenu = null;
  function candidats(el) {
    var d = el.ownerDocument, w = d.defaultView, l = [];
    for (var e = el.parentElement; e && e !== d.body && e !== d.documentElement; e = e.parentElement) {
      var s = w.getComputedStyle(e);
      if (/(auto|scroll)/.test(s.overflowY) && e.scrollHeight > e.clientHeight + 1) l.push(e);
    }
    var b = d.body, sb = w.getComputedStyle(b);
    if (/(auto|scroll)/.test(sb.overflowY) && b.scrollHeight > b.clientHeight + 1) l.push(b);
    var se = d.scrollingElement || d.documentElement;
    if (l.indexOf(se) < 0) l.push(se);
    if (retenu && l.indexOf(retenu) > 0) { l.splice(l.indexOf(retenu), 1); l.unshift(retenu); }
    return l;
  }
  function defileur(el) { return retenu || candidats(el)[0]; }
  // Toujours une POSITION ABSOLUE, jamais un écart : sur iPhone, un écart (scrollBy) est ajouté par l'écran à sa propre
  // position, qui peut être en retard sur celle de la page : compensation perdue ou doublée (versions 7 et 8).
  // Une position absolue arrive au même endroit même appliquée deux fois (code source de WebKit, vérifié le 08.10).
  // Immédiate (« instant »), jamais douce, même si un « scroll-behavior: smooth » est imposé par la page ou le lecteur.
  function allerA(sc, but) {
    var cibles = sc === document.documentElement ? [sc] : [sc, document.documentElement];
    var anciens = cibles.map(function (x) { return [x.style.getPropertyValue("scroll-behavior"), x.style.getPropertyPriority("scroll-behavior")]; });
    cibles.forEach(function (x) { x.style.setProperty("scroll-behavior", "auto", "important"); });
    try { sc.scrollTo({ top: but, behavior: "instant" }); } catch (e) { sc.scrollTop = but; }
    cibles.forEach(function (x, i) { if (anciens[i][0]) x.style.setProperty("scroll-behavior", anciens[i][0], anciens[i][1]); else x.style.removeProperty("scroll-behavior"); });
  }
  // pas d'ancrage du navigateur sur l'élément qui défile, quel qu'il soit (en plus de la règle CSS sur html et body)
  (function () { var b0 = sectionEl.querySelector(".pil__btn"); if (b0) candidats(b0).forEach(function (x) { x.style.overflowAnchor = "none"; }); })();
  // Compense l'écart du titre : chaque candidat reçoit la position absolue qui ramène le titre ; on garde le premier
  // qui a réellement bougé (lu tout de suite, dans la même tâche : pas de boucle par image).
  function compenser(btn, haut) {
    var l = candidats(btn), bouge = null;
    for (var i = 0; i < l.length; i++) {
      var sc = l[i], ecart = btn.getBoundingClientRect().top - haut;
      if (Math.abs(ecart) <= 0.5) break;
      var avant = sc.scrollTop, cible = Math.max(0, Math.round(avant + ecart));
      allerA(sc, cible);
      var ok = Math.abs(sc.scrollTop - avant) >= 1;
      if (ok) { bouge = sc; retenu = sc; }
    }
    return bouge || defileur(btn);
  }
  // Redemande la position qui remet le titre à sa place, recalculée depuis le document. Sans condition : si l'écran y
  // est déjà, rien ne bouge (WebKit renvoie juste sa position) ; s'il a perdu la demande, il y va. Abandonnée au toucher.
  function reaffirmer(sc, btn, haut, quand) {
    var reste = btn.getBoundingClientRect().top - haut;
    allerA(sc, Math.max(0, Math.round(sc.scrollTop + reste)));
  }
  var relances = [];
  function annulerRelance() { if (relances.length) { relances.forEach(clearTimeout); relances = []; } }
  ["touchstart", "pointerdown", "wheel", "keydown"].forEach(function (t) { window.addEventListener(t, annulerRelance, { capture: true, passive: true }); });
  function ouvrir(c, net) {
    var btn = c.querySelector(".pil__btn"), pan = c.querySelector(".pil__panneau");
    if (btn.getAttribute("aria-expanded") === "true") return;
    annulerRelance();
    var haut = btn.getBoundingClientRect().top, dessusOuvert = false;
    var dessus = cartes.filter(function (x) { return x !== c && (x.compareDocumentPosition(c) & Node.DOCUMENT_POSITION_FOLLOWING) && !x.querySelector(".pil__panneau").hidden; });
    dessusOuvert = dessus.length > 0;
    if (dessusOuvert && !net) {
      // Après un lien d'ancre (puces, « ton niveau »), Safari garde l'ancre et y ramène la vue à chaque mise en page,
      // ce qui défait la compensation. Un défilement sur place, avant le repli, l'efface sans rien bouger.
      var se = document.scrollingElement || document.documentElement;
      if (se.scrollTop > 0) allerA(se, se.scrollTop);
    }
    cartes.forEach(function (x) {
      if (x === c) return;
      fermer(x, net || !!(x.compareDocumentPosition(c) & Node.DOCUMENT_POSITION_FOLLOWING));
    });
    if (dessusOuvert && !net) {
      // position absolue, calculée dans la même tâche que le repli (même envoi à l'écran)
      var sc = compenser(btn, haut);
      // filet : deux images plus tard, si un navigateur a quand même déplacé le titre, on redemande la position
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        var reste = btn.getBoundingClientRect().top - haut;
        if (Math.abs(reste) > 2) allerA(sc, Math.max(0, Math.round(sc.scrollTop + reste)));
      }); });
      // Sur iPhone, juste après un défilement demandé, la page lit sa propre position (optimiste), pas celle de l'écran,
      // qui peut avoir perdu la demande sans le dire. Deux rappels de la même position absolue, à 150 et 450 ms.
      relances = [150, 450].map(function (ms, i) {
        return setTimeout(function () { if (i === 1) relances = []; reaffirmer(sc, btn, haut, ms + " ms"); }, ms);
      });
    }
    clearTimeout(minuteries.get(c));
    btn.setAttribute("aria-expanded", "true");
    c.classList.add("is-ouvert");
    pan.hidden = false;
    void pan.offsetHeight;
    pan.classList.add("is-open");
    c.dataset.ouvertA = performance.now();
    setTimeout(examiner, 370);
    entreeRegle(c);
    jouerIcone(c);
  }
  cartes.forEach(function (c) {
    var btn = c.querySelector(".pil__btn");
    btn.addEventListener("click", function () {
      if (btn.getAttribute("aria-expanded") === "true") fermer(c); else ouvrir(c);
    });
  });
  // les puces du bloc noir ouvrent leur pilier ; les autres se ferment sans animation pour que le saut vers l'ancre tombe juste
  sectionEl.querySelectorAll('.verdict__puces a[href^="#pilier-"]').forEach(function (a) {
    a.addEventListener("click", function () {
      var c = sectionEl.querySelector(a.getAttribute("href"));
      if (c) ouvrir(c, true);
    });
  });

  /* ---- Entrées à l'écran du pilier ouvert à l'arrivée : réglette et icône ; scènes ---- */
  if (!REDUIT && "IntersectionObserver" in window) {
    var opts = { threshold: 0.6, rootMargin: "0px 0px -8% 0px" };
    var obsRegles = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        var bloc = e.target;
        obsRegles.unobserve(bloc);
        if (!bloc.classList.contains("is-pre")) return;
        void bloc.offsetWidth;
        bloc.classList.add("is-entree");
        bloc.classList.remove("is-pre");
        setTimeout(function () { bloc.classList.remove("is-entree"); }, 800);
      });
    }, opts);
    var obsIcones = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        obsIcones.unobserve(e.target);
        var c = e.target.closest(".pil");
        if (c.classList.contains("is-ouvert")) jouerIcone(c);
      });
    }, opts);
    cartes.forEach(function (c) {
      if (!c.classList.contains("is-ouvert")) return;
      var bloc = c.querySelector(".regle-bloc");
      if (!visible(bloc)) bloc.classList.add("is-pre");
      obsRegles.observe(bloc);
      obsIcones.observe(c.querySelector(".pil__tuile"));
    });
  }

  /* ---- Scènes : elles partent quand on est dessus ----
     Pas au clic sur le pilier : la scène reste sur sa première image jusqu'à ce qu'elle soit bien visible
     (au moins 70 % d'elle, ou la moitié de l'écran si elle est plus haute que lui), son milieu entre 8 % et 85 %
     de la hauteur de l'écran, le pilier déplié (350 ms), et qu'elle le reste 200 ms, même si on défile encore
     doucement. Un passage rapide (moins de 200 ms dans la zone) ne la lance pas. */
  var attentes = new Map(), examenPrevu = false;
  function prete(s) {
    var c = s.closest(".pil");
    if (!c || !c.classList.contains("is-ouvert") || performance.now() - (+c.dataset.ouvertA || 0) < 350) return false;
    var r = s.getBoundingClientRect(), vh = window.innerHeight;
    if (r.height === 0) return false;
    var vu = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
    var milieu = (r.top + r.bottom) / 2;
    return vu >= Math.min(r.height * 0.7, vh * 0.5) && milieu > vh * 0.08 && milieu < vh * 0.85;
  }
  function examiner() {
    examenPrevu = false;
    if (REDUIT) return;
    scenes.forEach(function (s) {
      var ok = s.classList.contains("pause") && prete(s);
      if (ok && !attentes.has(s)) attentes.set(s, setTimeout(function () { attentes.delete(s); if (s.classList.contains("pause") && prete(s)) jouer(s); }, 200));
      if (!ok && attentes.has(s)) { clearTimeout(attentes.get(s)); attentes.delete(s); }
    });
  }
  function prevoirExamen() { if (!examenPrevu) { examenPrevu = true; requestAnimationFrame(examiner); } }
  // une scène revient à sa première image quand son pilier se ferme : elle rejouera quand on reviendra dessus
  function rearmer(c) {
    var s = c.querySelector(".scene");
    if (!s || REDUIT) return;
    s.classList.remove("joue", "pause");
    void s.getBoundingClientRect();
    s.classList.add("joue", "pause");
  }
  if (!REDUIT) {
    scenes.forEach(function (s) { s.classList.add("joue", "pause"); });
    document.addEventListener("scroll", prevoirExamen, { capture: true, passive: true }); // aussi quand c'est <body> ou un conteneur qui défile
    window.addEventListener("resize", prevoirExamen);
    setTimeout(examiner, 400);
  }
  function jouer(s) {
    if (REDUIT) return;
    if (s.classList.contains("pause")) { s.classList.remove("pause"); return; }
    s.classList.remove("joue");
    void s.getBoundingClientRect();
    s.classList.add("joue");
  }
  sectionEl.querySelectorAll(".rejouer").forEach(function (b) {
    if (REDUIT) { b.hidden = true; return; }
    b.addEventListener("click", function () { jouer(b.closest(".scene")); });
  });
})();
